import { render, staticRenderFns } from "./BottomMenuCabinet.vue?vue&type=template&id=72ab173e"
import script from "./BottomMenuCabinet.vue?vue&type=script&lang=js"
export * from "./BottomMenuCabinet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports